import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { getRequest } from 'src/utils/request';

import type { RequestData } from 'src/types/requestData';

const mapFieldCategory = (
  fieldCategory: UCM.FieldCategoryRawType,
  fieldCategoryId: string,
): UCM.FieldCategoryType => ({
  id: fieldCategoryId,
  uuid: fieldCategory.uuid,
  position: fieldCategory.position,
  name: {
    de: fieldCategory.name_de,
    en: fieldCategory.name_en,
  },
});

const getFieldCategory = async (fieldCategoryUuid: string) => {
  const {
    data: { data },
  } = await getRequest<RequestData<UCM.FieldCategoryRawType>>(
    API.GET.fieldCategory(fieldCategoryUuid),
  );

  return mapFieldCategory(data.attributes, data.id);
};

export const useGetFieldCategory = (
  uuid: string,
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.FIELD_CATEGORY, uuid],
    queryFn: () => getFieldCategory(uuid),
    staleTime: 1000 * 60 * 5, // Dashboards refreshed after every 5 minutes automatically
    ...config,
  });
};
